// @core/api/endpoints/team/create_team_role_application.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTeamRoleApplicationRequest,
} from '../../../types/team';

const BASE_PATH = '/team';

/**
 * Request role change
 * Submits a request to change your role within the team. Team admins review and approve role change requests.
 */
export async function CreateTeamRoleApplication(
  team_id: string,
  data: CreateTeamRoleApplicationRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:team_id/role-applications`;
  requestPath = requestPath.replace(':team_id', encodeURIComponent(team_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
